import * as React from 'react';
import { Translate } from 'react-redux-i18n';
import * as copy from 'copy-to-clipboard';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../../../reducers';
import { Label } from './styles';
import { InputWrapper, Button } from '../../styles';
import { savePublicationSettings } from '../../../../../containers/Editor/actions';
import { createNotification } from '../../../../../containers/NotificationBar/actions';
import { Api } from '../../../../../typings/api';

interface CopyPublicationUrlProps {
	publicationId: number;
	customUrl: string;
	projectUrl: string;
	isDisabled: boolean;
	dispatch: Dispatch<StoreState>;
}

const getPublicationUrl = (projectUrl: string, customUrl: string, publicationId: number): string => {
	const customUrlSeparator = '/.';
	const isCustomUrlInProjectUrl = projectUrl.includes(customUrlSeparator);
	const pathRegExp = isCustomUrlInProjectUrl
		? /\/\..*/
		: new RegExp(`\\/${publicationId}\\/?`);
	const domain = projectUrl.replace(pathRegExp, '');
	const newPath = customUrl ? `.${customUrl.replace(/\s/g, '_')}` : publicationId;

	return `${domain}/${newPath}/`;
};

const CopyPublicationUrl = ({
	publicationId,
	customUrl,
	projectUrl,
	isDisabled,
	dispatch,
}: CopyPublicationUrlProps) => {
	const initialCustomUrl = React.useRef<string>(customUrl);

	const handleClick = async () => {
		let publicationUrl = getPublicationUrl(projectUrl, customUrl, publicationId);
		copy(publicationUrl);

		if (customUrl !== initialCustomUrl.current) {
			const newPublicationUrl = await dispatch(savePublicationSettings(publicationId, {
				customUrl: customUrl.replace(/\s/g, '_'),
			} as Api.PublicationSettings));

			// server can change publicationUrl in some cases, e.g., 'my/url' will be cut to just 'my'
			if (newPublicationUrl && newPublicationUrl !== publicationUrl) {
				copy(newPublicationUrl);
			}

			initialCustomUrl.current = customUrl;
		}

		dispatch(createNotification('info.url_copied'));
	};

	return (
		<>
			<Label value="messages.project_url" />
			<InputWrapper hasNoIcon={true}>
				<input
					type="text"
					value={getPublicationUrl(projectUrl, customUrl, publicationId)}
					disabled={true}
				/>
			</InputWrapper>
			<Button
				onClick={handleClick}
				disabled={isDisabled}
			>
				<Translate value="messages.copy" />
			</Button>
		</>
	);
};

export default CopyPublicationUrl;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SettingsPanel/CopyPublicationUrl/index.tsx